module.exports = __webpack_public_path__ + "static/img/2.8ee82d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/pharmacy/3/2.png
// module id = sRpJ
// module chunks = 1